export const formatNumber = (number: number | string, type?: "short" | "full") => {
  const formatType = type || "full";
  const numberAsNumberType = typeof number === "number" ? number : parseInt(number);

  if (formatType === "short") {
    if (numberAsNumberType > 1000000) {
      return `${(numberAsNumberType / 1000000).toFixed(0)}m`;
    }

    if (numberAsNumberType > 10000) {
      return `${(numberAsNumberType / 1000).toFixed(0)}k`;
    }
  }

  if (typeof number === "string") {
    return parseInt(number).toLocaleString();
  }

  if (number) {
    return (number.toLocaleString());
  }

  return "";
};
